<template>
  <ul>
    <li v-for="(option, index) in available" :key="index">
      <input type="checkbox" :id="compId + index" :checked="checked(option.value)" @change="onChange($event.target.checked, option.value)" />
      <label :for="compId + index">{{ option.label }}</label>
    </li>
  </ul>
</template>

<script lang="ts">
import _uniqueId from 'lodash.uniqueid';
import { defineComponent, PropType } from 'vue';

export interface ControlCheckboxesOption {
  value: string
  label: string
}

export default defineComponent({
  name: 'ControlCheckboxes',
  props: {
    available: { type: Array as PropType<ControlCheckboxesOption[]>, required: true },
    modelValue: { type: Array as PropType<string[]>, required: true }
  },
  data() {
    return {
      compId: _uniqueId('control-checkboxes-')
    }
  },
  methods: {
    checked(value: string) {
      return this.modelValue.includes(value)
    },
    onChange(checked: boolean, value: string) {
      const valueSet = new Set(this.modelValue)
      if (checked) {
        valueSet.add(value)
      } else {
        valueSet.delete(value)
      }
      this.$emit('update:modelValue', Array.from(valueSet));
    }
  }
});
</script>
